module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-12 copia.1b91a300.webp";